import request from '../../api/request';
import { FileRequiredTypes, SecureResponseFile } from './types';

const ENDPOINTS = {
  UPLOAD: (type: string) => `/teacher-portal/azure-files-uploader/${type}`,
};

export const uploadFile = (file: File, fileType?: FileRequiredTypes) => {
  const formData = new FormData();
  formData.append('file', file);

  return request<SecureResponseFile>(
    ENDPOINTS.UPLOAD(fileType || FileRequiredTypes.HelpFiles),
    {
      method: 'POST',
      data: formData,
    },
  );
};
